import { RecordOf } from 'immutable';
import { createSelector } from 'reselect';

import { RootState } from '../types';
import { AuthState } from './types';

export default class AuthSelectors {
  static selectAuth = (state: RootState): RecordOf<AuthState> => state.auth;

  static getAccessToken = createSelector([AuthSelectors.selectAuth], (auth) => auth.accessToken);

  static getExpireTime = createSelector([AuthSelectors.selectAuth], (auth) => auth.expires);

  static isTokenValid = createSelector(
    [AuthSelectors.selectAuth],
    (auth) => !!auth.accessToken && (auth.expires || 0) > Date.now(),
  );
}
